<script>
// Path: src\layouts\TheDefaultLayout.vue

import { defineComponent } from "vue";

export default defineComponent({
  name: "TheDefaultLayout",
});
</script>

<template>
  <Dialog
    id="p-dialog-mask"
    v-model:visible="showModel"
    :style="{ width: scrollerWidth }"
    :show-header="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    class="dormer window-icons"
    :closable="false"
    append-to="self"
    :modal="modal"
    :base-z-index="zIndex"
    @hide="closeWindow(current)"
    @click.alt.ctrl="handleAltCtlClick"
  >
    <!--
  @click.alt.ctrl="handleAltCtlClick"
    @requestWindowOverlap="handleWinOverlap(current)" -->
    <template #header>
      <div class="flex">
        <Icon
          v-if="service.favicon != ''"
          type="favicon"
          :icon="service.favicon"
        />
        <label class="gem-main-heading ml-2">
          {{ startLabel }} {{ headerName }} {{ serviceName }}
        </label>
      </div>

      <div class="btn btn2 close-dialog-btn" @click="newWindow" />
      <div class="btn btn1 mx-2" @click="minimizeWindow" />
      <div class="btn btn3" @click="closeWindow(current)" />
    </template>

    <slot></slot>
  </Dialog>
</template>
